import { render, staticRenderFns } from "./RegistrarAsistenciaModal.vue?vue&type=template&id=2b33aec7&scoped=true"
import script from "./RegistrarAsistenciaModal.vue?vue&type=script&lang=js"
export * from "./RegistrarAsistenciaModal.vue?vue&type=script&lang=js"
import style0 from "./RegistrarAsistenciaModal.vue?vue&type=style&index=0&id=2b33aec7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b33aec7",
  null
  
)

export default component.exports